// extracted by mini-css-extract-plugin
module.exports = {"container":"e_4B","sizeSmall":"e_5B","on":"e_6B","handle":"e_7B","variantGrey":"e_8B","variantPrimary":"e_9B"};